export default __webpack_public_path__ + "static/CentraNo2-Thin-5422008a75ce1db8f1bd49f625e39875.woff2";